<template>
  <div class="seats-counter__container">
    <div class="seats-counter__image">
      <img :src="imageSrc" />
    </div>
    <div class="seats-counter__textbox">
      <div class="seats-counter__headline">
        {{ $t("headline") }}
      </div>
      <div class="seats-counter__seats">
        {{ seatsCopy }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SeatsCounter",
  props: {
    maxSeats: { type: Number, default: null },
    filledSeats: { type: Number, default: null },
    imageSrc: { type: String, default: "" }
  },
  computed: {
    seatsCopy() {
      let filledSeatsCopy = this.filledSeats
      let maxSeatsCopy = this.maxSeats

      if (!filledSeatsCopy) {
        filledSeatsCopy = 0
      }

      return `${filledSeatsCopy}/${maxSeatsCopy || 0}`
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Seats taken:"
      },
      de: {
        headline: "Vergebene Lizenzen:"
      }
    }
  }
}
</script>

<style lang="scss">
.seats-counter {
  &__textbox {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: $spacing-8 $spacing-8 $spacing-16;

    background-color: $white;
  }

  &__image {
    img {
      display: block;

      max-width: 100%;
    }
  }

  &__headline {
    @include font-style(h4);

    margin-right: $spacing-16;

    color: $midnight;
  }

  &__seats {
    @include font-style(h2);

    color: $midnight;
  }
}
</style>
